import '../../constants/ColorCodes.css';

const ConfigureDocumentation = () => {
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', margin: '0', padding: '0', color: 'var(--textcolor)', backgroundColor: 'var(--background)' }}>
            <div>
                <div>
                    <p>Technik: <a href="http://www.teach-r.de" target="_blank" rel="noopener noreferrer">www.teach-r.de</a></p>
                    <p>Forschung: <a href="https://www.uni-potsdam.de/de/multimedia/projekte/anwendungen/vr-klassenzimmer" target="_blank" rel="noopener noreferrer">Link zur Universit&#228;t Potsdam</a></p>
                    <p>Lehre und Historie: <a href="https://www.e-teaching.org/praxis/erfahrungsberichte/simulationsbasierte-lehramtausbildung-mit-teach-r" target="_blank" rel="noopener noreferrer">e-teaching.org</a></p>
                    <p>Bei Fragen und Anmerkungen, melden Sie sich gern bei Axel Wiepke <a href="mailto:axel.wiepke@uni-potsdam.de">axel.wiepke@uni-potsdam.de</a></p>
                </div>
            </div>
        </div>
    );
};

export default ConfigureDocumentation;